export function publicResultsLiveWindowPlan(liveUpdates = {}, now = Date.now()) {
  const startsAt = Date.parse(liveUpdates.starts_at);
  const endsAt = Date.parse(liveUpdates.ends_at);
  const enabled = Boolean(liveUpdates.enabled);
  const valid = enabled && !Number.isNaN(startsAt) && !Number.isNaN(endsAt) && endsAt > startsAt;

  return {
    enabled: valid,
    startsAt,
    endsAt,
    shouldScheduleStart: valid && now < startsAt,
    shouldSubscribe: valid && now >= startsAt && now < endsAt
  };
}

export function liveModeFromAction(currentMode, action) {
  if (action === 'live') return true;
  if (action === 'static' || action === 'publication') return false;
  return Boolean(currentMode);
}

export function publicResultsPublicationTerminal(publication = {}) {
  return ['official', 'withdrawn'].includes(publication.results_publication_status);
}
